import { PhoneNumberUtil, PhoneNumberType, PhoneNumberFormat, PhoneNumber } from 'google-libphonenumber';
import { CountryData, defaultCountries, parseCountry } from 'react-international-phone';

const phoneUtil = PhoneNumberUtil.getInstance();

const getExampleNumber = (region: string): PhoneNumber => {
  try {
    return phoneUtil.getExampleNumberForType(region, PhoneNumberType.MOBILE);
  } catch {
    return phoneUtil.getExampleNumber(region);
  }
};

const formatSubscriberNumber = (region: string, number: PhoneNumber): string => {
  const national = phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
  const trunk = phoneUtil.getNddPrefixForRegion(region, true);
  return trunk && national.startsWith(trunk) ? national.slice(trunk.length).trimStart() : national;
};

export const getExamplePlaceholder = (iso2: string): string => {
  const region = iso2.toUpperCase();
  try {
    return formatSubscriberNumber(region, getExampleNumber(region));
  } catch {
    return '';
  }
};

const getFormatMask = (iso2: string): string | undefined => {
  const region = iso2.toUpperCase();
  try {
    return formatSubscriberNumber(region, getExampleNumber(region)).replace(/\d/g, '.');
  } catch {
    return undefined;
  }
};

export const getFlag = (iso2: string): string =>
  iso2
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65))
    .join('');

export const buildCountriesData = (iso2List?: string[]): CountryData[] => {
  if (!iso2List || iso2List.length === 0) return defaultCountries;

  return iso2List.flatMap((iso2) => {
    const base = defaultCountries.find((c) => parseCountry(c).iso2 === iso2.toLowerCase());
    if (!base) return [];
    const { name, iso2: parsedIso2, dialCode, format, priority, areaCodes } = parseCountry(base);
    const mask = getFormatMask(iso2) ?? format;
    return [[name, parsedIso2, dialCode, mask, priority, areaCodes] as CountryData];
  });
};
